export const ItemTypes = {
  GROUP: 'group',
  ITEM: 'item',
  USAGE: 'usage',
} as const;
